import { axiosInstance, type CustomResponseFormat } from "api/instance";

export const RISK_DOMAIN = "risk";

export const RISK_DETAIL_ENDPOINT = "detail";
export const RISK_REPORT_ENDPOINT = "report";
export const RISK_SKIP_ENDPOINT = "skip";

export type RiskType = "self_harm_suicide";

export interface RiskDetailType {
  riskType: RiskType;
  taskKeyList: string[];
  thoughtRecordKey?: string;
  isReportedToMedicalStaff: boolean;
  guideMessageForChat: string;
}

export const riskApi = {
  getDetail: (pid: number) =>
    axiosInstance.get<CustomResponseFormat<RiskDetailType>>(
      `${RISK_DOMAIN}/${RISK_DETAIL_ENDPOINT}`,
      { params: { pid: pid } }
    ),

  report: (pid: number) =>
    axiosInstance.post<void>(
      `${RISK_DOMAIN}/${RISK_REPORT_ENDPOINT}`,
      undefined,
      { params: { pid: pid } }
    ),
  skip: (pid: number) =>
    axiosInstance.post<void>(
      `${RISK_DOMAIN}/${RISK_SKIP_ENDPOINT}`,
      undefined,
      { params: { pid: pid } }
    ),
};